import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import { LanguageProvider } from "@/i18n";
import Index from "./pages/Index";
import EBook from "./pages/EBook";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Beschwerden from "./pages/Beschwerden";
import Bakteriophagen from "./pages/Bakteriophagen";
import DarmsanierungWien from "./pages/DarmsanierungWien";
import BeschwerdeDetail from "./pages/BeschwerdeDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminPasswordReset from "./pages/AdminPasswordReset";
import Termin from "./pages/Termin";
import Faq from "./pages/Faq";
import AdminTermine from "./pages/AdminTermine";
import AdminBlogList from "./pages/AdminBlogList";
import AdminBlogEdit from "./pages/AdminBlogEdit";
import AdminBlogStats from "./pages/AdminBlogStats";
import AdminSeo from "./pages/AdminSeo";
import AdminMikrobi from "./pages/AdminMikrobi";
import AdminMikrobiAnswers from "./pages/AdminMikrobiAnswers";
import AdminMikrobiCheck from "./pages/AdminMikrobiCheck";
import Veranstaltungen from "./pages/Veranstaltungen";
import VeranstaltungDetail from "./pages/VeranstaltungDetail";
import AdminEvents from "./pages/AdminEvents";
import NotFound from "./pages/NotFound";
import AdminDashboard from "./pages/AdminDashboard";
import Adventkalender from "./pages/Adventkalender";
import AdminAdvent from "./pages/AdminAdvent";

import { RequireAdmin } from "./components/admin/RequireAdmin";
import MikrobiGate from "./components/mikrobi/MikrobiGate";

const queryClient = new QueryClient();

const AppRoutes = () => (
  <Routes>
    {["", "/en"].map((prefix) => (
      <Route key={prefix || "de"} path={`${prefix}/`}>
        <Route index element={<Index />} />
        <Route path="e-book" element={<EBook />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:slug" element={<BlogPost />} />
        <Route path="blog/:slug/:section" element={<BlogPost />} />
        <Route path="bakteriophagen-therapie" element={<Bakteriophagen />} />
        <Route path="phagentherapie" element={<Bakteriophagen />} />
        <Route path="darmsanierung-wien" element={<DarmsanierungWien />} />
        <Route path="beschwerden" element={<Beschwerden />} />

        <Route path="beschwerden/:slug" element={<BeschwerdeDetail />} />
        <Route path="termin" element={<Termin />} />
        <Route path="faq" element={<Faq />} />
        <Route path="veranstaltungen" element={<Veranstaltungen />} />
        <Route path="veranstaltungen/:slug" element={<VeranstaltungDetail />} />
        <Route path="adventkalender" element={<Adventkalender />} />
      </Route>
    ))}

    <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
    <Route path="/admin/login" element={<AdminLogin />} />
    <Route path="/admin/passwort" element={<AdminPasswordReset />} />
    <Route path="/admin/blog" element={<RequireAdmin><AdminBlogList /></RequireAdmin>} />
    <Route path="/admin/blog/statistik" element={<RequireAdmin><AdminBlogStats /></RequireAdmin>} />
    <Route path="/admin/blog/:id" element={<RequireAdmin><AdminBlogEdit /></RequireAdmin>} />
    <Route path="/admin/termine" element={<RequireAdmin><AdminTermine /></RequireAdmin>} />
    <Route path="/admin/veranstaltungen" element={<RequireAdmin><AdminEvents /></RequireAdmin>} />
    <Route path="/admin/advent" element={<RequireAdmin><AdminAdvent /></RequireAdmin>} />
    <Route path="/admin/seo" element={<RequireAdmin><AdminSeo /></RequireAdmin>} />
    <Route path="/admin/mikrobi" element={<RequireAdmin><AdminMikrobi /></RequireAdmin>} />
    <Route path="/admin/mikrobi/antworten" element={<RequireAdmin><AdminMikrobiAnswers /></RequireAdmin>} />
    <Route path="/admin/mikrobi/check" element={<RequireAdmin><AdminMikrobiCheck /></RequireAdmin>} />

    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <AppRoutes />
          <MikrobiGate />
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);


export default App;
